export default __webpack_public_path__ + "static/media/step-2.a6a8e3ce.gif";